<h3 *ngIf="title" matSubheader>{{ title }}</h3>
<mat-list
  [avatar]="avatar"
  [twoLine]="twoLine"
  [dense]="dense"
  [interactive]="interactive"
  disableRipple
>
  <ng-container *ngFor="let item of items; trackBy: trackItem">
    <sn-list-item
      *ngIf="!item.hidden()"
      [item]="item"
      (click)="$event.stopPropagation(); onItemClick(item)"
    ></sn-list-item>
  </ng-container>
</mat-list>
